import { z } from 'zod';
import { SchemaEmail, SchemaTimestamp, ZodArrayToEnum } from '@axiom/types';
import { InterviewsStatus } from '@axiom/const';

import { ZodCandidateOpportunityCandidateStatuses } from './candidate-opportunities-candidate-statuses';
import { OpportunityStages } from './opportunity';
import { CandidateSchema } from './candidate';
import { CalendarSchema } from './calendar';
import { CalendarConversationSchema } from './calendar-conversation';
import { ClientRequestSchema } from './client-request';

const UserInterviewCandidateOpportunitySchema = z.object({
  candidate: CandidateSchema.pick({
    calculatedDisplayName: true,
    id: true,
    profileImageKey: true,
    profileImageName: true,
  }).extend({
    calendar: CalendarSchema.pick({
      id: true,
      timezone: true,
    }).nullable(),
    email: SchemaEmail,
  }),
  candidateStatus: ZodCandidateOpportunityCandidateStatuses,
  candidateStatusUpdatedAt: SchemaTimestamp,
});

export const UserInterviewSchema = z.object({
  accountId: z.string().uuid(),
  calendarConversation: CalendarConversationSchema.nullable(),
  candidateOpportunity: UserInterviewCandidateOpportunitySchema,
  clientRequest: ClientRequestSchema.nullable(),
  id: z.string().uuid(),
  interviewNumber: z.number().positive().min(1).default(1),
  interviewStatus: z.enum(ZodArrayToEnum(Object.values(InterviewsStatus))),
  jobName: z.string().nullable(),
  opportunityId: z.string().uuid(),
  ownerUserId: z.string().uuid().nullable(),
  salesLeadId: z.string().uuid().nullable(),
  salesforceCXLeadId: z.string().uuid().nullable(),
  stage: z.enum(OpportunityStages).nullable(),
  submissionId: z.string().uuid(),
});

export type UserInterview = z.infer<typeof UserInterviewSchema>;
